import { render, staticRenderFns } from "./imageFram.vue?vue&type=template&id=bd2a75ea&scoped=true&"
import script from "./imageFram.vue?vue&type=script&lang=js&"
export * from "./imageFram.vue?vue&type=script&lang=js&"
import style0 from "./imageFram.vue?vue&type=style&index=0&id=bd2a75ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2a75ea",
  null
  
)

export default component.exports